import i18n from '@/mixins/i18n';
import AuthAPI from '@/utils/AuthAPI';

// Route guard to set the current locale flag on the routes.
function setLocaleFromRoute(route) {
    const locale = route.params.locale;
    const supported_locales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
    
    if (!supported_locales.includes(locale)) {
        route.params.locale = 'en';
        return route;
    }
    
    if (i18n.locale !== locale) i18n.locale = locale;
    return true;
}

// Route guard to check if the current user is authorized (logged). 
async function authorizedUser() {
    try {
        const [ success ] = await AuthAPI.currentUser();
        return success;
    } catch { return false; }
}

// Route guard to check if the current user is an administrator.
async function adminUser() {
    try {
        const [ success, imAdmin ] = await AuthAPI.imAdmin();
        return success && imAdmin;
    } catch { return false; }
}

function isReportService(query) {
    const { clinic, apiKey, frecuency, accumulated } = query;

    if (
        !clinic || !apiKey || 
        !['monthly', 'weekly', 'daily', ''].includes(frecuency) ||
        !['false', 'true'].includes(accumulated)
    ) return false;

    return true;
}

async function isAnonymousUser(token) {
    const [ success ] = await AuthAPI.anonymousUser(token);
    return !!token && success;
}

async function isAnonymousUserByAccountId(accountId) {
    const [ success ] = await AuthAPI.anonymousUserByAccountId(accountId);
    return !!accountId && success;
}

export {
    setLocaleFromRoute, authorizedUser, adminUser, isReportService, isAnonymousUser, isAnonymousUserByAccountId
}